import React, { createContext, useState, useContext } from 'react';

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
    // Directory Page State
    const [directoryState, setDirectoryState] = useState({
        query: '',
        category: null,
        results: [],
        lastDoc: null,
        hasMore: true,
        isLoaded: false // To distinguish between "initial empty" and "no results"
    });

    // Helper to update specific fields
    const updateDirectoryState = (updates) => {
        setDirectoryState(prev => ({ ...prev, ...updates }));
    };

    // Reset to initial state (e.g., when user clicks "Clear Filters")
    const resetDirectoryState = () => {
        setDirectoryState({
            query: '',
            category: null,
            results: [],
            lastDoc: null,
            hasMore: true,
            isLoaded: false
        });
    };

    return (
        <SearchContext.Provider value={{ directoryState, updateDirectoryState, resetDirectoryState }}>
            {children}
        </SearchContext.Provider>
    );
};

export const useSearch = () => useContext(SearchContext);
